<div class="BestFlight">
  <div class="bgColor">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="titleTop">
            <h3>{{ "topDestination.title" | translate }}</h3>
          </div>
        </div>
        <section class="container" *ngIf="!destinationView">
          <h2 class="bestFlight_title">
            {{ "topDestination.bestFlights" | translate }}
          </h2>
          <div class="row mb-3">
            <ng-container *ngFor="let card of cards; let i = index">
              <div
                *ngIf="card.tripIdeas == true"
                class="col-6 col-md-3 bestFlight"
                (click)="gotoSearchResult(card)"
              >
                {{ "topDestination.bestFlightsDesc" | translate }}
                <span class="" *ngIf="translate.currentLang == 'en'">{{
                  card.distination
                }}</span
                ><span class="title" *ngIf="translate.currentLang == 'ar'">{{
                  card.distinationAr
                }}</span>
              </div>
            </ng-container>
          </div>
          <div class="row mb-3 airlines">
            <p
              *ngFor="let airline of airlines"
              class="col-6 col-md-4 col-lg-3 col-xl-2 mt-2"
              [routerLink]="generateAirlineLink(airline.slug)"
            >
              {{
                airline.allAirlineInfoDtos[langIndex].airlineName | uppercase
              }}
            </p>
          </div>
          <!-- <div class="row mb-3 airlines">
                            <p *ngFor="let airline of airlines | slice:5" class="col-6 col-md-4 col-lg-3 col-xl-2 mt-2" [routerLink]="'/'+translate.currentLang+ '/airlines/' +'/' + airline.slug">
                            {{airline.allAirlineInfoDtos[languageIndex].airlineName | uppercase}}
                            </p>
                        </div> -->
        </section>
      </div>
    </div>
  </div>
</div>
